import { render, staticRenderFns } from "./powertms.vue?vue&type=template&id=0f18a2a9&scoped=true"
import script from "./powertms.vue?vue&type=script&lang=js"
export * from "./powertms.vue?vue&type=script&lang=js"
import style0 from "./powertms.vue?vue&type=style&index=0&id=0f18a2a9&prod&scoped=true&lang=css"
import style1 from "./powertms.vue?vue&type=style&index=1&id=0f18a2a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f18a2a9",
  null
  
)

export default component.exports